import { useState, useCallback } from "react";

type useIncrementorReturnType = [number, () => void];

/**
 * Returns a counter, particularly useful for incrementing keys
 * to force component reinstantiation.
 *
 * @returns [count, incrementCount]
 */
export const useIncrementor = (initialCount = 0): useIncrementorReturnType => {
  const [count, setCount] = useState(initialCount);
  const incrementCount = useCallback(() => {
    setCount(count + 1);
  }, [count, setCount]);
  return [count, incrementCount];
};
